import { BASE_URL } from '../API/BASE_URL';

export const getParticipants = async () => {
  const response = await fetch(BASE_URL + 'participants/participants/?limit=100', {
    method: 'GET',
  });

  const data = await response.json();

  return data;
};
